import React, { useState, useEffect } from "react";
import {
  getElectionDetails,
  addElectionDetails,
  getUSStateCollection
} from "../Database/firebase";
import { isEmpty} from "lodash";
import { Redirect } from "react-router-dom";

import Header from "../Components/Header";
import * as firebase from "firebase";
import { Layout, Row, Col, Card, message, Modal } from "antd";

import ElectionForm from "../Components/ElectionForm";
import CountryStateTable from "../Components/CountryStateTable";
const state = [ 
  { name: "Alabama", biden: 46, trump: 47},
  { name: "Alaska" , biden: 46, trump: 47},
  {name: "Arizona", biden: 46, trump: 47},
  {name : "Arkansas", biden: 46, trump: 47},
  {name: "California", biden: 46, trump: 47},
  {name: "Colorado" , biden: 46, trump: 47},
  {name: "Connecticut", biden: 46, trump: 47},
  {name: "Delaware" , biden: 46, trump: 47},
  {name: "Florida" , biden: 46, trump: 47},
  {name: "Georgia" , biden: 46, trump: 47},
  {name: "Hawaii" , biden: 46, trump: 47},
  {name: "Idaho" , biden: 46, trump: 47},
  {name: "Illinois", biden: 46, trump: 47},
  {name: "Indiana" , biden: 46, trump: 47},
  {name: "Iowa", biden: 46, trump: 47},
  {name: "Kansas" , biden: 46, trump: 47},
  {name: "Kentucky" , biden: 46, trump: 47},
  {name: "Louisiana" , biden: 46, trump: 47},
  {name: "Maine", biden: 46, trump: 47},
  {name: "Maryland" , biden: 46, trump: 47},
  {name: "Massachusetts" , biden: 46, trump: 47},
  {name: "Michigan" , biden: 46, trump: 47},
  {name: "Minnesota" , biden: 46, trump: 47},
  {name: "Mississippi" , biden: 46, trump: 47},
  {name: "Missouri" , biden: 46, trump: 47},
  {name: "Montana" , biden: 46, trump: 47},
  {name: "Nebraska" , biden: 46, trump: 47},
  {name: "Nevada", biden: 46, trump: 47} ,
  {name: "New Hampshire", biden: 46, trump: 47},
  {name: "New Jersey" , biden: 46, trump: 47},
  {name: "New Mexico" , biden: 46, trump: 47},
  {name: "New York", biden: 46, trump: 47},
  {name: "North Carolina", biden: 46, trump: 47},
  {name: "North Dakota", biden: 46, trump: 47},
  {name: "Ohio" , biden: 46, trump: 47},
  {name: "Oklahoma" , biden: 46, trump: 47},
  {name: "Oregon" , biden: 46, trump: 47},
  {name: "Pennsylvania" , biden: 46, trump: 47},
  {name: "Rhode Island", biden: 46, trump: 47},
  {name: "South Carolina" , biden: 46, trump: 47},
  {name: "South Dakota", biden: 46, trump: 47},
  {name: "Tennessee", biden: 46, trump: 47},
  {name: "Texas" , biden: 46, trump: 47},
  {name: "Utah", biden: 46, trump: 47},
  {name: "Vermont", biden: 46, trump: 47},
  {name: "Virginia", biden: 46, trump: 47},
  {name: "Washington", biden: 46, trump: 47},
  {name: "West Virginia", biden: 46, trump: 47},
  {name: "Wisconsin", biden: 46, trump: 47},
  {name: "Wyoming", biden: 46, trump: 47},
]

const { Content } = Layout;

const ElectionPage = () => {
  const [loggedIn, setLoggedIn] = useState(null);
  const [user, setUser] = useState(null);
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [description, setDescription] = useState("");
  const [electionState, setElectionState] = useState(false);
  const [electionDetailsCollection, setElectionDetailsCollection] = useState([]);

  useEffect(() => {
    const tempArry = [];
    // setLoading(true);

    getElectionDetails.then((snapshot) => {
      // setLoading(false);
      if (!isEmpty(snapshot)) {
        snapshot.forEach((doc) => {
          console.log("=============== data ========>>>>>>", doc.data())
          // debugger
          tempArry.push({ ...{ id: doc.id }, ...doc.data() });
        });
        setElectionDetailsCollection(tempArry);
      }
    });

    getUSStateCollection.then((snapshot) => {
      console.log("============= USSTATECOLLECTIOM ==========>>>>>")
      if (!isEmpty(snapshot)) {
        snapshot.forEach((doc) => {
          console.log("===============USSTATECOLLECTIOM  data ========>>>>>>", doc.data())
          // debugger
          // tempArry.push({ ...{ id: doc.id }, ...doc.data() });
        });
        setElectionDetailsCollection(tempArry);
      }
    });

    // Get User from localstorage
    let user = localStorage.getItem("User");
    if (user) {
      setLoggedIn(true);
      setUser(JSON.parse(user));
    } else {
      setLoggedIn(false);
    }
  }, []);

  const logout = () => {
    firebase
      .auth()
      .signOut()
      .then(function () {
        // Sign-out successful.
        localStorage.clear();
        setLoggedIn(false);
      })
      .catch(function (error) {
        // An error happened.
        console.error(error);
      });
  };

  const resetState = () => {
    setTitle("");
    setDescription("");
    setSubTitle("");
    setElectionState(false);
  }

  const onSubmit = () => {
    console.log("================ onChange ====>");

    if (isEmpty(title) || isEmpty(subTitle) || isEmpty(description)) return;

    const electionDetails = {
      title,
      subTitle,
      description,
      electionState
    }
    console.log("================= electionDetails ========>>>", electionDetails);
    addElectionDetails(electionDetails)
    .then((res) => {
      debugger
    })
    .catch(error => {
      debugger
    })
  }

  const onCancelEditMode = () => {
    console.log("================ onCancelEditMode ====>")
  }

  const onChangehandle = (value, name) => {
    console.log("================ onChange ====>", value, name);
    switch(name) {
      case "title":
        setTitle(value);
        break;
      case "description":
        setDescription(value);
        break;
      case "subTitle":
        setSubTitle(value);
        break;
      case "electionState":
        setElectionState(value);
        break;
    }
  }
  console.log("============== electionDetailsCollection ", electionDetailsCollection)
  if (loggedIn === null) return <div />;
  if (loggedIn === false) return <Redirect to={"/"} />;
  
  return(
    <div className="election-page">
      <Layout className="layout" style={{ background: "#1f2228" }}>
        <Header logout={logout} componentName="LatestArticlePage" />
        <Content style={{ padding: "0 10px", background: "#1f2228" }}>
          <div className="site-layout-content">
            <Row>
              <Col span={24}>
                <Card style={{ borderRadius: "15px" }}>
                  <ElectionForm
                    onChangehandle={onChangehandle}
                    onSubmit={onSubmit}
                    editMode={false}
                    onCancelEditMode={onCancelEditMode}
                    electionDetailsCollection={electionDetailsCollection}
                  />
                </Card>
              </Col>
            </Row>
            <Row>
              <Col flex={2}>
                <Card style={{ marginTop: 10, borderRadius: "15px" }}>
                  <CountryStateTable 
                    loading={false}
                    countryStateData={state}
                  />
                </Card>
              </Col>
            </Row>
          </div>
        </Content>
      </Layout>
    </div>
  )
}

export default ElectionPage;
